module.exports = __webpack_public_path__ + "static/media/sbahn-echtzeit.08d74af8.svg";